export const MODIFY_PRO_BLOCK_TOO_MANY_FILES = 'MODIFY_PRO_BLOCK_TOO_MANY_FILES';

export function modifyProBlockTooManyFiles(proBlockTooManyFiles){
    return{
        type: MODIFY_PRO_BLOCK_TOO_MANY_FILES,
        mainState: {
            proBlockTooManyFiles: proBlockTooManyFiles
        }
    }
}